import { render, staticRenderFns } from "./editSelect.vue?vue&type=template&id=39b1c634&scoped=true"
import script from "./editSelect.vue?vue&type=script&lang=js"
export * from "./editSelect.vue?vue&type=script&lang=js"
import style0 from "./editSelect.vue?vue&type=style&index=0&id=39b1c634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1c634",
  null
  
)

export default component.exports